import { render } from "./BdcomEponTable.vue?vue&type=template&id=e1193d7e&scoped=true"
import script from "./BdcomEponTable.vue?vue&type=script&lang=js"
export * from "./BdcomEponTable.vue?vue&type=script&lang=js"

import "./BdcomEponTable.vue?vue&type=style&index=0&id=e1193d7e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\oltcare-front\\olt_care\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1193d7e"]])

export default __exports__